module.exports = __webpack_public_path__ + "assets/images/logo-image-only-white.dd4c8b0d8d3684ad7eaa35235799d5e2.png";